import React, { createContext, useContext, useMemo } from "react";

export type SocialProofMessages = {
  productId: string;
  messages: {
    title: string;
    id: string;
    description: string;
  }[];
};

type SocialProofMessagesContextType = {
  messages: SocialProofMessages[];
};

const SocialProofMessagesContext =
  createContext<SocialProofMessagesContextType | null>(null);

export function SocialProofMessagesProvider({
  children,
  messages,
}: {
  children: React.ReactNode;
  messages: SocialProofMessages[];
}) {
  const value = useMemo<SocialProofMessagesContextType>(
    () => ({
      messages,
    }),
    [messages],
  );

  return (
    <SocialProofMessagesContext.Provider value={value}>
      {children}
    </SocialProofMessagesContext.Provider>
  );
}

export function useSocialProofMessages() {
  const context = useContext(SocialProofMessagesContext);
  if (!context) {
    throw new Error(
      "useSocialProofMessages must be used within a SocialProofMessagesProvider",
    );
  }
  return context;
}
